import Resource from '@/api/resources/Resource'

class ComplementaryServices extends Resource {
    async getAllComplementariesByCaseId(labId, casId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/complementaries`)
        return response.data
    }

    async getComplementaryById(labId, casId, complementaryId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}`)
        return response.data
    }
    async createComplementary(labId, casId, complementaryRequest) {
        const response = await this.axios.post(`/diagnosis/laboratories/${labId}/cases/${casId}/complementaries`, complementaryRequest)
        return response.data
    }
    async updateComplementary(labId, casId, complementaryId, complementaryRequest) {
        const response = await this.axios.put(`/diagnosis/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}`, complementaryRequest)
        return response.data
    }
    async deleteComplementary(labId, casId, complementaryId) {
        const response = await this.axios.delete(`/diagnosis/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}`)
        return response.data
    }
    async validateComplementary(labId, casId, complementaryId) {
        const response = await this.axios.put(`diagnosis/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}/validate`)
        return response.data
    }
    async removeValidationComplementary(labId, casId, complementaryId) {
        const response = await this.axios.put(`diagnosis/laboratories/${labId}/cases/${casId}/complementaries/${complementaryId}/removeValidation`)
        return response.data
    }
}

export default new ComplementaryServices()
